module.exports = __webpack_public_path__ + "static/media/p5.57e23027.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/p5.jpg
// module id = 139
// module chunks = 0